<template>
  <div class="user-notes-container">
    <div class="heading-icon" style="background-color: #2a9d8f">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14,2 14,8 20,8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10,9 9,9 8,9"></polyline>
      </svg>
    </div>

    <h1 class="title-with-underline">{{ titleBlock.title || '請填寫就診資訊' }}</h1>

    <div class="notes-content">
      <div v-if="titleBlock.content" class="title-desc">
        {{ titleBlock.content }}
      </div>

      <!-- main input area -->
      <div class="input-section" v-if="labelBlock">
        <label class="input-label">{{ labelBlock.title }}</label>
        <b-form-textarea
          v-model="localNotes"
          :placeholder="labelBlock.content || '請輸入備註'"
          rows="5"
          max-rows="10"
          @input="onInput"
          class="custom-textarea"
        ></b-form-textarea>
      </div>

      <!-- description notes -->
      <div class="notes-section" v-if="noteBlocks.length > 0">
        <div v-for="(block, index) in noteBlocks" :key="index" class="note-item">
          <span class="note-text">
            <template v-if="block.title"><b>{{ block.title }}</b></template>
            {{ block.content }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserNotes',
  props: {
    notesConfig: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localNotes: this.value || ''
    }
  },
  computed: {
    titleBlock() {
      return this.notesConfig.find(b => parseInt(b.order) < 0) || { title: '請填寫就診資訊 (本頁為選填)', content: '' };
    },
    labelBlock() {
      return this.notesConfig.find(b => parseInt(b.order) >= 0 && parseInt(b.order) < 15) || { title: '請描述您本次健檢的原因 / 期待？', content: '' };
    },
    noteBlocks() {
      return this.notesConfig.filter(b => parseInt(b.order) >= 15);
    }
  },
  watch: {
    value(newVal) {
      if (this.localNotes !== newVal) {
        this.localNotes = newVal;
      }
    }
  },
  methods: {
    onInput() {
      this.$emit('input', this.localNotes);
    }
  }
}
</script>

<style scoped>
.user-notes-container {
  /* same as other components if there is a wrapper style needed */
}

.notes-content {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}

.title-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  text-align: center;
}

.input-section {
  margin-bottom: 24px;
}

.input-label {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  display: block;
}

.custom-textarea {
  border-radius: 8px;
  border: 1px solid #ced4da;
  padding: 12px;
  font-size: 16px;
}

.custom-textarea:focus {
  border-color: #2a9d8f;
  box-shadow: 0 0 0 0.2rem rgba(42, 157, 143, 0.25);
}

.notes-section {
  margin-top: 24px;
}

.note-item {
  margin-bottom: 16px;
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}

.note-item:last-child {
  margin-bottom: 0;
}

@media screen and (max-width: 768px) {
  .notes-content {
    padding: 16px;
  }
  
  .input-label {
    font-size: 16px;
  }
}
</style>
